<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        <i class="mdi mdi-voice"></i>
        <span class="ml-2">
            {{noticeInfo.title}}
        </span>
    </h4>
</div>

<div class="modal-body">
    <div class="d-flex justify-content-between align-items-center">
        <div class="">
            <i class="mdi mdi-clock"></i>
            <span class="ml-1">
                {{noticeInfo.updateDt}}
            </span>
        </div>
        <div class="">
            <i class="mdi mdi-bell-ring-outline"></i>
            <span class="ml-1">
                {{noticeInfo.noticeType}}
            </span>
        </div>
    </div>
    <hr class="my-2">
    <div class="px-2" style="min-height: 25vh;"
        [innerHtml]="parseContent(noticeInfo.content)">
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            닫기
        </span>
    </button>
</div>
